module.exports = __webpack_public_path__ + "img/catalogDoor2.png?b352ec73cff387a94925ee8ee00e9892";